/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Registration response
 */
export interface GoldenTransferRegistrationAck {
  txHash: string;
  result: GoldenTransferRegistrationAck.ResultEnum;
}
export namespace GoldenTransferRegistrationAck {
  export const ResultEnum = {
    Applied: 'APPLIED',
    Updated: 'UPDATED',
    Ignored: 'IGNORED',
  } as const;
  export type ResultEnum = (typeof ResultEnum)[keyof typeof ResultEnum];
}
